
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Use original Supabase URL to fix OAuth flow
// Custom domain setup pending proper configuration
const SUPABASE_URL = "https://odvlpcanslnszwczgxxc.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9kdmxwY2Fuc2xuc3p3Y3pneHhjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDc5NTA2NzEsImV4cCI6MjA2MzUyNjY3MX0.bipcX6pKKGgpQVJRVKbL_L0g5r_askW61YhslHEM8E4";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});
